import { Button, Caption, css, Paragraph, styled, withSpace, WithSpaceProps } from 'canoe';

export const PlacementSteps = styled.div`
  ${({ theme }) => css`
    flex-grow: 1;
    min-height: 0;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: ${theme.spaces.s};
    padding: ${theme.spaces.s} ${theme.spaces.xs};
  `}
`;

export const ActiveStepHeader = styled.div<{ center?: boolean }>`
  ${({ center }) => css`
    display: flex;
    flex-direction: column;
    align-items: ${center ? 'center' : 'flex-start'};
  `}
`;

export const StepCircle = styled.div`
  ${({ theme }) => css`
    width: 40px;
    height: 40px;
    background-color: ${theme.colors.Success};
    color: ${theme.colors.White};
    font-size: 24px;
    line-height: 38px;
    font-weight: ${theme.fontWeights.bold};
    border-radius: 50%;
    text-align: center;
    vertical-align: middle;
  `}
`;

export const StepTitle = styled(Paragraph)<{ active?: boolean }>`
  ${({ theme, active }) => css`
    color: ${theme.colors.GlitterGrayL30};
    font-weight: ${theme.fontWeights.bold};
    margin: 0;
    ${!active &&
    css`
      padding-left: ${theme.spaces.xs};
    `}
  `}
`;

export const StepSectionTitle = styled(Paragraph)`
  ${({ theme }) => css`
    color: ${theme.colors.White};
    font-weight: ${theme.fontWeights.medium};
    font-size: 14px;
    margin: ${theme.spaces.xs} 0 0;
  `}
`;

export const StepSubtitle = styled(Caption)<{ simpleMode?: boolean }>`
  ${({ theme, simpleMode }) => css`
    color: ${theme.colors.GlitterGrayL30};
    margin: 0;
    ${
      !simpleMode &&
      css`
        padding-left: ${theme.spaces.xs};
      `
    }
    margin-bottom: ${theme.spaces.s};
  `}
`;

export const CompletedStepSettings = styled.div<{ hasError?: boolean; hasWarning?: boolean }>`
  ${({ theme, hasError, hasWarning }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${theme.spaces.s};
    padding: ${theme.spaces.xs} ${theme.spaces.xxs} ${theme.spaces.xs} ${theme.spaces.xs};
    margin-top: ${theme.spaces.xs};
    border-radius: ${theme.borderRadius.small};
    background-color: ${theme.colors.OnyxGray};
    font-size: ${theme.fonts.small.fontSize};
    color: ${theme.colors.White};

    ${hasError &&
    `
      border: 1px solid ${theme.colors.Danger};
    `}
    ${hasWarning &&
    `
      border: 1px solid ${theme.colors.Warning};
    `}
  `}
`;

export const EditLinkButton = styled(Button)`
  ${({ theme }) => css`
    flex-shrink: 0;
    text-decoration: underline;
    font-size: ${theme.fonts.small.fontSize};
  `}
`;

export const CardsContainer = styled.div<WithSpaceProps>`
  ${({ theme }) => css`
    display: flex;
    flex-wrap: nowrap;
    gap: ${theme.spaces.xs};
    ${withSpace};
  `}
`;
